import React, { Component } from 'react'
import { shape, string, func } from 'prop-types'
import { view } from '@risingstack/react-easy-state'
import { translate } from 'react-i18next'
import { Gardeners } from '../gardeners/Gardeners'
import { stores } from '../../stores'
import { Loader } from '../ui/states/Loader'
import { NavigationButtons } from '../ui/buttons/NavigationButtons'
import { withRouter } from 'react-router'
import { pushGtmTrigger } from '../../utilities/window'
import { InquiryPathVersions } from '../../stores/inquiry'

class GardenersStepComponent extends Component {
  async componentDidMount () {
    // Only skip if the user didn't deselect all from gardeners page
    if (stores.search.fromJardiniers && stores.inquiry.selected.length) {
      this.next()
    }
    pushGtmTrigger(
      stores.inquiry.pathVersion === InquiryPathVersions.V1
        ? 'select_content'
        : 'select_content_v2'
    )
  }

  next () {
    stores.inquiry.selected = stores.search.selected
    stores.search.fromJardiniers = false
    this.props.next()
  }

  render () {
    const { match, t, previous, onPostalCodeChange } = this.props

    if (stores.search.loading) {
      return (<Loader />)
    }

    return (<div>
      <div className='demande__container no_max_width --with-padding-bottom'>
        <Gardeners
          onPostalCodeChange={(code) => onPostalCodeChange(code)}
          city={stores.search.search.city || match.params.code}
          selected={stores.search.selected}
          jardiniers={stores.search.gardeners} />
        <div className='form__submit' style={{ justifyContent: 'center' }}>
          <NavigationButtons
            previous={previous}
            next={() => this.next()}
            disabled={!stores.search.selected.length}
            label={t('common:buttons:validate_gardeners', { count: stores.search.selected.length })}
          />
        </div>
      </div>
    </div>)
  }
}

GardenersStepComponent.propTypes = {
  t: func,
  match: shape({
    params: shape({
      code: string
    })
  }),
  previous: func,
  next: func,
  onPostalCodeChange: func
}

export const GardenersStep = translate()(withRouter(view(GardenersStepComponent)))



// WEBPACK FOOTER //
// ./src/components/inquiry/GardenersStep.js